import { FormInstance, Radio } from "antd";
import Search from "antd/es/input/Search";

import FlexContainer from "@/components/FlexContainer";

import {
    StyledForm,
    StyledFormItem,
    StyledFormItemRadio,
    StyledRadioBtn,
} from "./Styled";

const dayOptions = [
    { value: "0", label: "Всі" },
    { value: "1", label: "Пн" },
    { value: "2", label: "Вт" },
    { value: "3", label: "Ср" },
    { value: "4", label: "Чт" },
    { value: "5", label: "Пт" },
    { value: "6", label: "Сб" },
    { value: "7", label: "Нд" },
];

export interface FiltersPanelValues {
    search: string;
    day: string;
}

export default function FiltersPanel({
    form,
}: {
    form: FormInstance<FiltersPanelValues>;
}) {
    return (
        <StyledForm
            form={form}
            layout="vertical"
            initialValues={{ search: "", day: "0" }}
        >
            <FlexContainer flexDirection="column" gap="10px">
                <StyledFormItem name="search">
                    <Search
                        placeholder="Введіть назву"
                        size="large"
                        allowClear
                    />
                </StyledFormItem>

                <StyledFormItemRadio name="day">
                    <Radio.Group size="middle">
                        {dayOptions.map(({ value, label }) => (
                            <StyledRadioBtn key={value} value={value}>
                                {label}
                            </StyledRadioBtn>
                        ))}
                    </Radio.Group>
                </StyledFormItemRadio>
            </FlexContainer>
        </StyledForm>
    );
}
